import React from "react";
import Activity_item from "../../components/collections/Activity_item";
import Meta from "../../components/Meta";
import { useWallet } from "@solana/wallet-adapter-react";
import Sol_Activity_item from "../../components/categories/solana/Activity_item";

const Activity = () => {
  const { connected } = useWallet();

  return (
    <>
      <Meta title="Nut  Market " />
      <section className="relative mt-24 lg:pb-48 pb-24 bg-jacarta-800">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <div className="container">
          <h1 className="font-display text-jacarta-200 py-16 text-center text-4xl font-medium ">
            Activity
          </h1>
          {connected ? (
            <Sol_Activity_item showState={"all"} />
          ) : (
            <Activity_item />
          )}
        </div>
      </section>
    </>
  );
};

export default Activity;
